<template>
  <BasicNav v-show="showNav" fixed>
    <template #left>
      <BasicIcon :name="leftIcon" @click="back" />
    </template>
    <template #center>
      <span class="nav-center">{{ title }}</span>
    </template>
    <template #right>
      <BasicIcon v-if="rightIcon" :name="rightIcon" @click="rightClick" />
      <slot v-else name="right"></slot>
    </template>
  </BasicNav>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import BasicNav from '~~/components/nav/BasicNav.vue'

const router = useRouter()
const showNav = ref(false)

const pageProps = defineProps({
  leftIcon: {
    type: String,
    default: 'nav_back_black',
  },
  title: {
    type: String,
    default: '',
  },
  rightIcon: {
    type: String,
    default: '',
  },
  customBack: {
    type: Function,
    default: null,
  },
})

onMounted(() => {
  showNav.value = true
})

const emits = defineEmits(['rightClick'])

const back = () => {
  if (pageProps.customBack) {
    pageProps.customBack()
  } else {
    router.back()
  }
}
const rightClick = () => {
  emits('rightClick')
}
</script>
<style lang="less" scoped>
.nav-center {
  max-width: 230px;
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: keep-all;
  white-space: nowrap;
  font-family: @bold;
  color: @Text50;
}
</style>
